export default {
  swedbank: 'swed',
  seblt: 'seb',
  dnb: 'dnb',
  sb: 'siauliu',
  lt_nordea: 'nordea',
  citadele: 'citadele',
};
